import { render } from "./ConfirmComponent.vue?vue&type=template&id=7572c74e&ts=true"
import script from "./ConfirmComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__